import React from 'react';
import { Link } from 'react-router-dom';
import s from './Member.module.css';
import user from './../../../assets/img/unknown150.jpg';

const Member = ({name, is_online}) => {

    return (
        <>
        {is_online
        ?
        <Link to="#">
            <div className={`${s.member}`}>
                <div className={s.memberImage}>
                    <img src={user} alt={name}/>
                </div>
                <div className={s.memberName}>{name}</div>
            </div>
        </Link>
        : ""
        }
            
        </>
    )
}

export default Member
